import { render, staticRenderFns } from "./backup.vue?vue&type=template&id=58ab158a&scoped=true"
import script from "./backup.vue?vue&type=script&lang=js"
export * from "./backup.vue?vue&type=script&lang=js"
import style0 from "./backup.vue?vue&type=style&index=0&id=58ab158a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ab158a",
  null
  
)

export default component.exports